<template>
  <b-tooltip
    v-if="showIcon"
    :label="tooltipLabel"
    :position="position"
    :append-to-body="appendToBody">
    <b-icon
      icon="alert"
      :type="iconType"
      :size="size"/>
  </b-tooltip>
</template>

<script>
import { LIMITE_AU_PAIEMENT_COMPTANT, TOTAL } from '@/configuration/clientConf';
import levelString from '@/services/client/levelToString';

export default {
  name: 'NiveauBlocageIcone',

  props: {
    niveau: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: null,
    },
    position: {
      type: String,
      default: 'is-bottom',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showIcon() {
      return this.niveau === LIMITE_AU_PAIEMENT_COMPTANT.toString()
        || this.niveau === TOTAL.toString();
    },

    iconType() {
      return this.niveau === LIMITE_AU_PAIEMENT_COMPTANT.toString()
        ? 'is-warning'
        : 'is-danger';
    },

    tooltipLabel() {
      return levelString(this.niveau);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/NiveauBlocageIcone.vue